export default __webpack_public_path__ + "static/media/Sally Zheng - Internal Relations Associate.ab00979d.jpg";